import $ from 'jquery';

class HeaderScroll  {

  constructor(currentStatus) {
    // console.log('HeaderScroll constructor');
    this.isAnchor = false;

    this.checkIfAnchor();
    $('.overlay-menu li.menu-item-has-children > a').after('<span class="submenu-toggle" role="presentation"></span>');
    setTimeout(() => {
      this.detectScroll();
      this.manageHeaderSubMenus();
    }, 400);
  }

  checkIfAnchor() {
    let hash = window.location.hash;

    if( hash ) {

      let urlHash = hash.substring(1);

      if( urlHash == 'management' ) {
        this.isAnchor = true;
      }
      setTimeout(() => {
        this.isAnchor = false;
      }, 2000);
    }
  }

  detectScroll() {
    let lastScrollTop = 0;
    let ticking = false;
    let isAnchor = this.isAnchor || false;

    const $window = $(window);
    const $header = $('.site-header');
    const $mainHeader = $('.header--main');
    const stickyOffset = $header.position().top + 250;

    function onScroll() {
      let scrollToTop = $window.scrollTop();

      if (scrollToTop > 100 && !isAnchor) {
        if (scrollToTop > lastScrollTop) {
          if (!$mainHeader.hasClass('scrolled')) {
            $mainHeader.addClass('scrolled');
          }
        } else {
          if ($mainHeader.hasClass('scrolled')) {
            $mainHeader.removeClass('scrolled');
          }
        }
        lastScrollTop = scrollToTop;
      }

      if (scrollToTop > stickyOffset) {
        if (!$header.hasClass('scroll-mid')) {
          $header.addClass('scroll-mid');
        }
      } else {
        if ($header.hasClass('scroll-mid')) {
          $header.removeClass('scroll-mid');
        }
      }

      ticking = false;
    }

    $window.on('scroll', function () {
      if (!ticking) {
        window.requestAnimationFrame(onScroll);
        ticking = true;
      }
    });
  }

  manageHeaderSubMenus(){
    $('.overlay-menu li.menu-item-has-children > .submenu-toggle').on('click', function(e){
      $(this).parent().toggleClass('active');
      // console.log('clicked', $(this).parent().parent());
      
    });
  }

}


export default HeaderScroll;